import Api from "./axios";

export const createTicket = async (data) => {
    const response = await Api.post(`/create-ticket`, data);
    return response;
}